import { render, staticRenderFns } from "./MediacontactProductTypeForm.vue?vue&type=template&id=4545bc73"
import script from "./MediacontactProductTypeForm.vue?vue&type=script&lang=js"
export * from "./MediacontactProductTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports